<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-right mt-1">
      <label>File name</label>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.sd_file_name" class="file_name_input"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <NameResolver fields-prefix="sd" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ToggleAllButton fields-prefix="sd" />
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_equinox_sel" class="mt-1">Equinox</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_equinox" class="fit-width">
        <option :value="null">Select...</option>
        <option>2000</option>
        <option>1950</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_dateobs_sel" class="mt-1">Obs date</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.sd_dateobs_min" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.sd_dateobs_min" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.sd_dateobs_min">{{fieldErrors.sd_dateobs_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-input-group>
        <b-form-input v-model="fields.sd_dateobs_max" placeholder="yyyy-MM-dd"></b-form-input>
        <b-input-group-append>
          <VueCtkDateTimePicker v-model="fields.sd_dateobs_max" format="YYYY-MM-DD" :no-label="true" :only-date="true" :no-value-to-custom-elem="true" :right="true">
            <button type="button" class="btn btn-secondary">
              <font-awesome-icon icon="calendar-alt" />
            </button>
          </VueCtkDateTimePicker>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="fieldErrors.sd_dateobs_max">{{fieldErrors.sd_dateobs_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_program_sel" class="mt-1">Project id</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_program"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_telescop_sel" class="mt-1">Telescope</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_telescop" class="fit-width">
        <option :value="null">Select...</option>
        <option>Medicina</option>
        <option>Noto</option>
        <option>SRT</option>
      </b-form-select>
    </div>
  </div>

  <div class="row" v-if="fields.sd_telescop === null">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_frontend_sel" class="mt-1">Frontend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_frontend" class="fit-width">
        <option :value="null">Select...</option>
        <option>LHP</option>
        <option>LLP</option>
        <option>CCC</option>
        <option>CHC</option>
        <option>XXP</option>
        <option>KKC</option>
        <option>PPP</option>
        <option>CCB</option>
        <option>KKG</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_backend_sel" class="mt-1">Backend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_backend" class="fit-width">
        <option :value="null">Select...</option>
        <option>TotalPower</option>
        <option>Xarcos</option>
        <option>Sardara</option>
      </b-form-select>
    </div>
  </div>

  <div class="row" v-if="fields.sd_telescop === 'Medicina'">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_frontend_sel" class="mt-1">Frontend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_frontend" class="fit-width">
        <option :value="null">Select...</option>
        <option>LHP</option>
        <option>LLP</option>
        <option>CCC</option>
        <option>CHC</option>
        <option>XXP</option>
        <option>KKC</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_backend_sel" class="mt-1">Backend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_backend" class="fit-width">
        <option :value="null">Select...</option>
        <option>TotalPower</option>
        <option>Xarcos</option>
        <option>Sardara</option>
      </b-form-select>
    </div>
  </div>

  <div class="row" v-if="fields.sd_telescop === 'Noto'">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_frontend_sel" class="mt-1">Frontend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_frontend" class="fit-width">
        <option :value="null">Select...</option>
        <option>LHP</option>
        <option>LLP</option>
        <option>CCC</option>
        <option>CHC</option>
        <option>XXP</option>
        <option>KKC</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_backend_sel" class="mt-1">Backend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_backend" class="fit-width">
        <option :value="null">Select...</option>
        <option>TotalPower</option>
      </b-form-select>
    </div>
  </div>

  <div class="row" v-if="fields.sd_telescop === 'SRT'">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_frontend_sel" class="mt-1">Frontend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_frontend" class="fit-width">
        <option :value="null">Select...</option>
        <option>LLP</option>
        <option>PPP</option>
        <option>CCB</option>
        <option>KKG</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_backend_sel" class="mt-1">Backend</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_backend" class="fit-width">
        <option :value="null">Select...</option>
        <option>TotalPower</option>
        <option>Xarcos</option>
        <option>Sardara</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_freq_sel" class="mt-1">Frequency [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_min_freq_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_min_freq_min">{{fieldErrors.sd_min_freq_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_max_freq_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_max_freq_max">{{fieldErrors.sd_max_freq_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_bandwid_sel" class="mt-1">Bandwidth [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_bandwid_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_bandwid_min">{{fieldErrors.sd_bandwid_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_bandwid_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_bandwid_max">{{fieldErrors.sd_bandwid_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_freqres_sel" class="mt-1">Spectral resolution [MHz]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_freqres_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_freqres_min">{{fieldErrors.sd_freqres_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_freqres_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_freqres_max">{{fieldErrors.sd_freqres_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_freq_bin_sel" class="mt-1">Frequency bins</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_freq_bin"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_restfreq_sel" class="mt-1">Rest frequency [MHz]</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_restfreq"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_exptime_sel" class="mt-1">Exposure time [s]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_exptime_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_exptime_min">{{fieldErrors.sd_exptime_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_exptime_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_exptime_max">{{fieldErrors.sd_exptime_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_lst_sel" class="mt-1">LST [s]</b-form-checkbox>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">From:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_lst_min"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_lst_min">{{fieldErrors.sd_lst_min}}</span>
    </div>
    <div class="col-1 label-right">
      <label class="mt-1">To:</label>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_lst_max"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.sd_lst_max">{{fieldErrors.sd_lst_max}}</span>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_scantype_sel" class="mt-1">Scan type</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_scantype" class="fit-width">
        <option :value="null">Select...</option>
        <option>CROSSCAN</option>
        <option>MAP</option>
        <option>ONOFF</option>
        <option>ON</option>
        <option>NODDING</option>
        <option>FOCUS</option>
        <option>SKYDIP</option>
      </b-form-select>
    </div>
    <!--
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_scanmode_sel" class="mt-1">Scan mode</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_scanmode" class="fit-width">
        <option :value="null">Select...</option>
        <option>OTF</option>
        <option>RASTER</option>
      </b-form-select>
    </div>
  -->
  </div>

  <!--
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_scangeom_sel" class="mt-1 ml-5">Scan geometry</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_scangeom" class="fit-width">
        <option :value="null">Select...</option>
        <option value="SINGLE">SINGLE</option>
        <option value="LINE">LINE</option>
        <option value="CROSS">CROSS</option>
        <option value="RRECT">RRECT</option>
        <option value="QUAD">QUAD</option>
        <option value="CIRC">CIRC</option>
        <option value="ARC">ARC</option>
        <option value="CURVE">CURVE</option>
        <option value="UNKNOWN">UNKNOWN</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_usrframe_sel" class="mt-1">Scan frame</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_usrframe" class="fit-width">
        <option :value="null">Select...</option>
        <option value="EQEQEQ">EQEQEQ</option>
        <option value="EQHOHO">EQHOHO</option>
        <option value="HOHOHO">HOHOHO</option>
        <option value="GAGAGA">GAGAGA</option>
        <option value="GAHOHO">GAHOHO</option>
      </b-form-select>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_scanxvel_sel" class="mt-1 ml-5">Scan speed [deg/min]</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_scanxvel"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_swtchmod_sel" class="mt-1 ml-5">Switch mode</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_swtchmod" class="fit-width">
        <option :value="null">Select...</option>
        <option value="TOTP">TOTP</option>
        <option value="FSW">FSW</option>
        <option value="BEAMSW">BEAMSW</option>
        <option value="HORNSW">HORNSW</option>
        <option value="LOADSW">LOADSW</option>
        <option value="CAL">CAL</option>
      </b-form-select>
    </div>
  </div>
-->

<!--
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_wobused_sel" class="mt-1">Wobbler</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.sd_wobused" class="fit-width">
        <option :value="null">Select...</option>
        <option :value="true">T</option>
        <option :value="false">F</option>
      </b-form-select>
    </div>
  </div>
-->

  <!--
  <div class="row">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_obsid_sel" class="mt-1 ml-5">Observer</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_obsid"></b-form-input>
    </div>
  </div>
-->

  <div class="row d-none">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_creator_sel" class="mt-1 ml-5">Creator</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_creator"></b-form-input>
    </div>
  </div>

  <div class="row d-none">
    <div class="col-3 label-left">
      <b-form-checkbox :disabled="toggleStatus" v-model="fields.sd_fitsver_sel" class="mt-1 ml-5">Format version</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.sd_fitsver"></b-form-input>
    </div>
  </div>
</div>
</template>

<script>
import NameResolver from './RadioNameResolver.vue';
import ToggleAllButton from './ToggleAllButton.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'SD',
  components: {
    NameResolver,
    ToggleAllButton
  },
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors,
    toggleStatus: state => state.searchForm.toggleStatus['sd']
  })
}
</script>
